import { render, staticRenderFns } from "./TradeRequestChatWithAdmin.vue?vue&type=template&id=f9aedc18&scoped=true"
import script from "./TradeRequestChatWithAdmin.vue?vue&type=script&lang=js"
export * from "./TradeRequestChatWithAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9aedc18",
  null
  
)

export default component.exports